import React from 'react';
import { FolderOpen, ClipboardList, Clock } from 'lucide-react';
import { Button } from '../ui/Button';
export function SolutionSection() {
  const scrollToCheckout = () => {
    document.getElementById('cta-box')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="w-full bg-stone-900 text-stone-50 py-16 md:py-24 px-4" data-id="element-188">
      <div className="max-w-5xl mx-auto" data-id="element-189">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-190">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-191">
            La solución: un tablero físico que cualquiera puede entender
          </h2>
          <p className="text-lg text-stone-300" data-id="element-192">
            <strong className="text-white" data-id="element-193">Cuidador Sin Caos</strong> es un kit
            imprimible que convierte cuidado desordenado en continuidad.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-194">
          {/* Piece 1 */}
          <div className="bg-stone-800 p-8 rounded-xl border border-stone-700 hover:border-stone-600 transition-colors" data-id="element-195">
            <div className="w-12 h-12 bg-stone-700 rounded-lg flex items-center justify-center mb-6 text-emerald-400" data-id="element-196">
              <FolderOpen className="w-6 h-6" data-id="element-197" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-198">1. Tablero 4 Carpetas</h3>
            <p className="text-stone-300 mb-4" data-id="element-199">
              Todo lo crítico vive en 4 categorías inevitables. Nada queda
              flotando.
            </p>
            <ul className="text-sm text-stone-400 space-y-2" data-id="element-200">
              <li className="flex items-center" data-id="element-201">• Medicación</li>
              <li className="flex items-center" data-id="element-202">• Turnos</li>
              <li className="flex items-center" data-id="element-203">• Documentación</li>
              <li className="flex items-center" data-id="element-204">• Emergencia</li>
            </ul>
          </div>

          {/* Piece 2 */}
          <div className="bg-stone-800 p-8 rounded-xl border border-stone-700 hover:border-stone-600 transition-colors" data-id="element-205">
            <div className="w-12 h-12 bg-stone-700 rounded-lg flex items-center justify-center mb-6 text-emerald-400" data-id="element-206">
              <ClipboardList className="w-6 h-6" data-id="element-207" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-208">2. Fichas de Guardia</h3>
            <p className="text-stone-300 mb-4" data-id="element-209">
              Una hoja diaria para delegar sin perder el control y sin explicar
              todo de nuevo.
            </p>
            <ul className="text-sm text-stone-400 space-y-2" data-id="element-210">
              <li className="flex items-center" data-id="element-211">• Qué toca hoy</li>
              <li className="flex items-center" data-id="element-212">• Qué observar</li>
              <li className="flex items-center" data-id="element-213">• Qué NO improvisar</li>
              <li className="flex items-center" data-id="element-214">• Qué queda pendiente</li>
            </ul>
          </div>

          {/* Piece 3 */}
          <div className="bg-stone-800 p-8 rounded-xl border border-stone-700 hover:border-stone-600 transition-colors" data-id="element-215">
            <div className="w-12 h-12 bg-stone-700 rounded-lg flex items-center justify-center mb-6 text-emerald-400" data-id="element-216">
              <Clock className="w-6 h-6" data-id="element-217" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-218">3. Registro Diario</h3>
            <p className="text-stone-300" data-id="element-219">
              Un registro mínimo de 3 minutos para que el cuidado no dependa de
              tu cabeza.
            </p>
            <div className="mt-6 pt-6 border-t border-stone-700" data-id="element-220">
              <p className="text-xs text-stone-400 italic" data-id="element-221">
                "Si tarda más de 20 minutos por semana, se rompe; por eso es
                minimalista."
              </p>
            </div>
          </div>
        </div>

        {/* CTA after solution reveal */}
        <div className="mt-16 text-center" data-id="element-222">
          <p className="text-stone-400 mb-4" data-id="element-223">
            ¿Ya te imaginás cómo sería tener todo en un solo lugar?
          </p>
          <div className="mb-6" data-id="element-224">
            <span className="text-3xl md:text-4xl font-bold text-white" data-id="element-225">
              $9.300
            </span>
            <span className="text-stone-400 ml-2" data-id="element-226">ARS</span>
          </div>
          <Button size="lg" withIcon onClick={scrollToCheckout} className="bg-emerald-600 hover:bg-emerald-700 text-white border-0" data-id="element-227">
            Quiero el Kit Completo
          </Button>
        </div>
      </div>
    </section>;
}